import * as _ from 'lodash'
// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
// Models
import { BusScheduleTemplate, BusSchedule } from '../models/BusModels'

@Injectable()
export class ChildrenServices {
    private apiUrl: string = '/api';
    private children: string = '/parent-children';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
    }

    // Get Chilren of logged parent
    getChildren() {
        let requestUrl = this.apiUrl + this.children;
        return this.apiService.get<any>(requestUrl);
    }
}


// WEBPACK FOOTER //
// ./src/bus/services/ChildrenServices.ts